import { axiosClient } from "@/shared/api/axios-client";
import type { CargarCFDIResultado } from "@/lib/types";

/**
 * Endpoint de carga de CFDI · `multipart/form-data`. Devuelve la
 * solicitud actualizada + flag de reglasAutorizadas + lista de errores
 * de reglas (vacía si reglasAutorizadas=true).
 */
export const cargarCfdiApi = {
  cargar: (solicitudId: string, xml: File) => {
    const form = new FormData();
    form.append("cfdi", xml);
    return axiosClient
      .post<CargarCFDIResultado>(`/api/solicitudes/${solicitudId}/cfdi`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};
